import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import contentFallback from "../data/content.json";
import QuotationCartButton from "./QuotationCartButton";
import { ResolveCmsIcon } from "./ResolveCmsIcon";
import { useCmsDoc } from "../hooks/useCmsDoc";
import { formatNavLink, normalizeNavigationDoc } from "../lib/navigationMenu";
import { useHeroChromeIdle } from "./HeroIdleChrome";

const BottomNav = () => {
  const location = useLocation();
  const chromeIdle = useHeroChromeIdle();
  const { data } = useCmsDoc("site", "navigation", normalizeNavigationDoc({}));
  const nav = normalizeNavigationDoc(data || {});

  const navItems = (nav.items || []).filter(
    (item) => item.showInBottomNav !== false && item.label !== "Inicio"
  );

  return (
    <nav className={`site-bottom-nav fixed bottom-0 left-0 right-0 z-[950] bg-white/90 backdrop-blur-xl border-t border-border shadow-[0_-5px_20px_rgba(0,0,0,0.05)] md:hidden pb-[env(safe-area-inset-bottom,10px)] pt-2 transition-[opacity,transform] duration-300 ${
      chromeIdle ? "pointer-events-none translate-y-full opacity-0" : "translate-y-0 opacity-100"
    }`}>
      <div className="flex items-center h-14 px-3 gap-2">
        <NavLink
          to="/"
          className="flex items-center justify-center rounded-full bg-[#658b10]/12 p-3 shadow-[0_4px_20px_rgba(101,139,16,0.18)] transition-transform duration-200 hover:scale-[1.05]"
        >
          <img
            src={contentFallback.logos.agdysa_logo}
            alt="AGDYSA"
            className="h-8 w-auto object-contain"
          />
        </NavLink>

        <div className="grid grid-cols-8 gap-0.5 flex-1">
          {navItems.map((item) => {
            if (item.label === "Cotizar") {
              return (
                <QuotationCartButton key={item.id} variant="icon">
                  <ResolveCmsIcon
                    icon={item.icon || "lucide:Receipt"}
                    size={20}
                    className="text-[#658b10]/40"
                    alt={item.label}
                  />
                </QuotationCartButton>
              );
            }

            const targetPath = formatNavLink(item.link);
            const isActive = location.pathname === targetPath;

            return (
              <NavLink
                key={item.id}
                to={targetPath}
                className="relative flex items-center justify-center rounded-2xl bg-white/80 p-2 transition-all duration-200 hover:bg-[#658b10]/5 group"
                title={item.label}
              >
                <motion.div
                  animate={{
                    scale: isActive ? 1.15 : 1,
                    y: isActive ? -1 : 0,
                  }}
                  className={`relative z-10 transition-all duration-200 group-hover:scale-125 group-focus-within:scale-125 ${
                    isActive ? "text-[#658b10]" : "text-[#658b10]/40"
                  }`}
                >
                  <ResolveCmsIcon
                    icon={item.icon}
                    size={20}
                    className={isActive ? "text-[#658b10]" : "text-[#658b10]/40"}
                    alt={item.label}
                  />
                </motion.div>
                {isActive && (
                  <motion.div
                    layoutId="bottomTabIndicator"
                    className="absolute -top-2 w-1.5 h-1.5 bg-[#658b10] rounded-full shadow-[0_0_8px_#658b10]"
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  />
                )}
              </NavLink>
            );
          })}
          {nav.formation?.enabled !== false && (
            <a
              href={nav.formation.url}
              target="_blank"
              rel="noopener noreferrer"
              className="relative flex items-center justify-center rounded-2xl bg-white/80 p-2 transition-all duration-200 hover:bg-[#658b10]/5 group"
              aria-label={nav.formation?.label || "Formación"}
            >
              <span className="transition-transform duration-200 group-hover:scale-125 group-focus-visible:scale-125">
                <ResolveCmsIcon
                  icon={nav.formation?.icon || "lucide:GraduationCap"}
                  size={20}
                  className="text-[#658b10]/40"
                  alt={nav.formation?.label || "Formación"}
                />
              </span>
            </a>
          )}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
